/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedLocationRequest
 */
export interface PatchedLocationRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedLocationRequest
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PatchedLocationRequest
   */
  declination?: string
  /**
   *
   * @type {number}
   * @memberof PatchedLocationRequest
   */
  regionId?: number | null
  /**
   *
   * @type {number}
   * @memberof PatchedLocationRequest
   */
  tagId?: number | null
}

/**
 * Check if a given object implements the PatchedLocationRequest interface.
 */
export function instanceOfPatchedLocationRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedLocationRequestFromJSON(json: any): PatchedLocationRequest {
  return PatchedLocationRequestFromJSONTyped(json, false)
}

export function PatchedLocationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedLocationRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    declination: !exists(json, 'declination') ? undefined : json['declination'],
    regionId: !exists(json, 'regionId') ? undefined : json['regionId'],
    tagId: !exists(json, 'tagId') ? undefined : json['tagId'],
  }
}

export function PatchedLocationRequestToJSON(value?: PatchedLocationRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    declination: value.declination,
    regionId: value.regionId,
    tagId: value.tagId,
  }
}
